import React from 'react';

import { DecisionMakerIcon } from '@change/ds-icons';

import { Button, Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/next';

import type { LegislativeBody } from '../../../shared/types';
import { LegislativeBodyCard } from '../index';

import { useViewMore } from './hooks/useViewMore';

export const ViewMore: React.FC<{ legislativeBody: LegislativeBody }> = ({ legislativeBody }) => {
	const { viewMoreText, allDMs } = legislativeBody;

	const {
		data: { title, petitionAsk },
	} = useViewMore(legislativeBody);

	return (
		<Modal
			size="large"
			onClose={() => {}}
			trigger={
				<Button data-qa="legislative-bodies-view-more" variant="tertiary">
					{viewMoreText}
				</Button>
			}
			className="z-[5000] lg:[&_*]:!col-span-full"
		>
			<ModalHeader
				leadingSlot={
					<div className="bg-fill-accent-primary-weaker text-typography-strong flex h-20 w-20 items-center justify-center rounded-full">
						<DecisionMakerIcon />
					</div>
				}
				title={title}
				subtitle={petitionAsk}
			/>
			<ModalBody className="!max-h-none">
				<LegislativeBodyCard legislativeBody={{ ...legislativeBody, viewMoreText: undefined, displayedDMs: allDMs }} />
			</ModalBody>
		</Modal>
	);
};
